'use strict';

var Controller = require('base/Colido.Controller');
var Error404View = require('modules/global/views/layout/error-404');

/**
 * Global Colido Controller
 *
 * @category   Controller
 * @module     global
 * @copyright  Copyright (c) 2016, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 * @author     Stefan Rueschenberg <sr@h-m.io>
 */
var AppController = Controller.extend({
    notFound: function(route) {
        var region = App.rootView.mainRegion.currentView.contentRegion;
        region.show(new Error404View());
    },

    removeTrailingSlash: function (path) {
        App.router.navigate(path, {trigger: true, replace: true});
    },
});

module.exports = AppController;

